import { pathOr } from "ramda";

import { ANALYTICS_GRAPH, mockPath } from "constants/app";
import { postRequest, checkStatus, parseStatusAndBody } from "helpers/requests";
import { IDayPart } from "types/account";

const MOCK_DAY_PARTS = `/dayParts`;

interface IGraphResponse {
  data: {
    store: {
      dayParts: IDayPart[];
    };
  };
}

const DAY_PARTS_GRAPH_QUERY = `query queryDayParts($store_pretty_url: String!) {
  store(prettyUrl: $store_pretty_url) {
    dayParts {
      name,
      startTimeHour,
      startTimeMinute,
      endTimeHour,
      endTimeMinute
    }
  }
}`
  .replace(/\s+/g, " ")
  .replace(/\n/g, "");

function getDayParts(
  brandId: string,
  storePrettyUrl: string
): Promise<IDayPart[]> {
  const dayPartsPath = mockPath(
    `${ANALYTICS_GRAPH}?brand_pretty_url=${brandId}`,
    MOCK_DAY_PARTS
  );

  const postParams = {
    query: DAY_PARTS_GRAPH_QUERY,
    variables: { storePrettyUrl },
  };

  return fetch(dayPartsPath, postRequest(postParams))
    .then((response) => parseStatusAndBody<IGraphResponse>(response))
    .then((parsedResponse: [number, IGraphResponse]) =>
      checkStatus<IGraphResponse>(parsedResponse)
    )
    .then(pathOr([], ["data", "store", "dayParts"]));
}

export { getDayParts };
